// extracted by mini-css-extract-plugin
module.exports = {"fixedFooter":"screens--Goals-module_fixedFooter-3yu9_"};